module.exports = __webpack_public_path__ + "static/img/map_guangxi.7cd88cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_guangxi.png
// module id = itLm
// module chunks = 0